import { render, staticRenderFns } from "./NewCompanyProgramForm.html?vue&type=template&id=6e08aada&external"
import script from "./NewWaveEditForm.vue?vue&type=script&lang=js"
export * from "./NewWaveEditForm.vue?vue&type=script&lang=js"
import style0 from "./NewWaveEditForm.vue?vue&type=style&index=0&id=6e08aada&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports